module.exports = __webpack_public_path__ + "img/patrulla_pcivil_down.8d89c60c.svg";